import YASQE from "@triply/yasqe";

const classesCompleter = {

    isValidCompletionPosition: function (yasqe) {
        return YASQE.Autocompleters.class.isValidCompletionPosition(yasqe);
    },
    preProcessToken: function (yasqe, token) {
        return YASQE.Autocompleters.class.preProcessToken(yasqe, token);
    },
    postProcessSuggestion: function (yasqe, token, suggestedString) {
        return YASQE.Autocompleters.class.postProcessSuggestion(yasqe, token, suggestedString);
    },
    name: "classesCompleter",
    bulk: true,
    async: false,
    autoShow: true,
    persistent: false,
    get: function (yasqe) {
        return yasqe.options.classList;
    }

};

export default classesCompleter;
